module.exports = __webpack_public_path__ + "img/jf-bg.f1a3cd3f.png";